const testimonials = [
  {
    quote:
      "Working with Mandie one-on-one was the most transformative experience of my life. I came in carrying thirty years of pain and left with a version of myself I didn't know existed.",
    name: 'Ama K.',
    role: '1:1 Client, London',
  },
  {
    quote:
      "The group container was medicine I didn't know I needed. Hearing other women speak the exact words I had been too afraid to say, that's when I knew I wasn't broken. I was just unseen.",
    name: 'Chidera O.',
    role: 'Group Coaching, Lagos',
  },
  {
    quote:
      "HOME rewired everything. Every week built on the last. By week twelve I wasn't the same woman who started. I finally understood what it meant to feel safe in my own body.",
    name: 'Nia T.',
    role: 'HOME, Accra',
  },

];

const starRow = (
  <div className="flex items-center gap-1 mb-4">
    {[0, 1, 2, 3, 4].map((i) => (
      <i key={i} className="ri-star-fill text-accent-500 text-sm" />
    ))}
  </div>
);

export default function WorkTestimonialsSection() {
  return (
    <section className="bg-background-100">
      {/* Full-bleed banner */}
      <div className="w-full h-48 md:h-64 lg:h-80 bg-[#6B1E3B] relative">
        <div className="absolute bottom-0 left-0 w-full h-px bg-[#C9A84C]/60" />
      </div>

      {/* Content */}
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-6xl mx-auto py-20 md:py-32 lg:py-36">
        {/* Section header */}
        <div className="text-center mb-16 md:mb-20">
          <p className="text-accent-600 text-xs font-body tracking-[0.25em] uppercase mb-5">
            Real women. Real transformation.
          </p>
          <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight">
            Words from women
            <br />
            who have done the work.
          </h2>
        </div>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className={testimonials.length % 2 !== 0 && testimonials.indexOf(t) === testimonials.length - 1 ? 'bg-background-50 rounded-lg p-6 md:p-8 border border-accent-500/15 md:col-span-2 md:max-w-md md:mx-auto' : 'bg-background-50 rounded-lg p-6 md:p-8 border border-accent-500/15'}
            >
              {starRow}
              <blockquote className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-6 italic">
                {t.quote}
              </blockquote>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-accent-500/20 flex items-center justify-center">
                  <span className="font-heading text-sm text-accent-700">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="font-body text-sm font-medium text-foreground-950">
                    {t.name}
                  </p>
                  <p className="font-body text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}